<template>
  <div class="baiduQueue">
      <div class="head">
        <img src="/static/index/index15.png" alt="">
        <div class="title">
            <div class="h1">人才召集令</div>
            <div class="h2">工程师e家线上招聘专场我们缺的就是你</div>
        </div>
        <div class="search">
          <div class="s1"><el-cascader placeholder="区域" :options="options" v-model="selectedOptions" @change="handleChangeData" :props="props"></el-cascader></div>
          <div class="s1">
              <el-select v-model="schooling" placeholder="学历" @change="getData">
                <el-option v-for="(item,index) in schoolingList" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
        </div>
          <div class="s1">
              <el-select v-model="experience" placeholder="经验" @change="getData">
                <el-option  v-for="(item,index) in experienceList" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <div class="s2" @click="getData">查询</div>
          <div class="s3" @click="apply">发布信息</div>
      </div>
      </div>
      <div class="box" v-for="(item,index) in list" :key="index" @click="jump(item)">
          <div class="b1">
              <div class="b11">
                  <div class="b111">{{item.title}}</div>
                  <div class="b112">{{item.salary}}</div>
              </div>
              <div class="b12">
                  <img src="/static/index/index6.png" alt="">
                  <div>{{item.orga.orgName}}</div>
              </div>
          </div>
          <div class="b2">
              <div class="b21">{{item.orga.city}}  |  {{item.experience}}  |  {{item.education}}</div>
              <div class="b22">{{item.premium}}</div>
          </div>
          <div class="b3">{{item.description}}</div>

      </div>
      <!-- <el-pagination
      background
        layout="prev, pager, next"
        :total="1000">
    </el-pagination> -->
    <footer1></footer1>
    <show ref="show"></show>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { regionData } from "element-china-area-data";
if(regionData[0].label=='北京市'){
    regionData.unshift({label:'全部',value:'000000',children:[{label:'全部',value:'000000',children:[{label:'全部',value:'000000'}]}]})
}

export default {
  title: "课程列表",
  data() {
    return {
    options: regionData,
    selectedOptions:[],
    props:{
        value:'label',
        label:'label'
    },
      input:'', // 搜索产品输入
      schoolingList:['不限','研究生','本科','专科','中专','职高','高中','初中','小学','其他'],
        schooling:null,
        experienceList:['不限','1年以内','1-3年','3-5年','5-10年','10年以上'],
        experience:null,
      index:'',
      list:[],
      chooseCity:[],

    };
  },
  computed: {},
  components: {},
  methods: {
      jump(e){
          this.$router.push({
            path:'/recruitmentDetail',
            query:{
              id:e.jid
            }
          })
      },
      apply(){
          if(!Cookie.get('id')){
              this.$message.error("请登录");
                return;
          }
          this.$axios.post(`/do_oper_job`,this.$qs.stringify({crud:-1,aid:Cookie.get('id')})).then(res => {
			  if(res.data.data.oid==-1){
                  this.$refs.show.click()
                    return;
              }else{
                  this.$router.push('/applyRecruitment')
              }
			})
          
      },
      handleChangeData(value) {
          if(value[0]=="全部"){
              this.chooseCity=[]
              this.selectedOptions=[]
          }else{
              this.chooseCity=value
          }
          this.getData()
    },
    update(e){
      this.index=e.typeId
      this.getData()
    },
    getData() {
      let obj={
            crud:2,
            jobJson:JSON.stringify({
                orga:{
                    city:this.chooseCity.length==0?null:this.chooseCity[1]!='市辖区'?this.chooseCity[1]:this.chooseCity[0]
                },
                education:this.schooling=='' || this.schooling=='不限' ?null:this.schooling,
                title:null,
                experience:this.experience=='' || this.experience=='不限'?null:this.experience
            })
        }
        this.$axios.post(`/do_oper_job`,this.$qs.stringify(obj)).then(res => {
            this.list=res.data.data
        })
    },
  },

  mounted() {
    this.$axios.post(`/do_oper_retailer`,this.$qs.stringify({crud:-2})).then(res => {
      this.categoryList=res.data.data
      this.categoryList.unshift({typeName:'全部',typeId:0})
      this.index=this.categoryList[0].typeId
      this.getData()
    })
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // display: flex;
  // flex-direction: column;
//   padding-bottom: 50px;
//   background: #F8F8F8;
  .head{
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 72px;
    &>img{
        width: 100%;
        height: 100%;
        position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .title{
        width: 1200px;
        z-index: 1;
        .h1{
            font-size: 50px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 44px;
        }
        .h2{
            font-size: 30px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            width: 530px;
        }
    }
    .search{
      width: 1200px;
      height: 135px;
    background: #85A9CD;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 377px;
    transform: translate(-50%,0);
    display: flex;
    align-items: center;
    justify-content: center;
    .s1{
        width: 250px;
        height: 66px;
        border-radius: 6px;
        border: 3px solid #FFFFFF;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .el-input__inner{
            border: none;
            background: transparent;
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            &::placeholder {
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            }
        }
        /deep/ .el-input__icon{
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
        }
        &>img{
            width: 24px;
            height: 24px;
            
        }
        &>.el-input{
            width: 60%;
        }
        
    }
    .s2{
        width: 128px;
        height: 66px;
        background: #FFFFFF;
        border-radius: 6px;
        text-align: center;
        line-height: 66px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #0457AD;
        margin-right: 20px;
    }
    .s3{
        width: 122px;
        height: 60px;
        border-radius: 6px;
        border: 3px solid #FFFFFF;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
    }
  }
  }
}
.box{
    padding: 26px 30px;
    width: calc(1200px - 60px);
    height: auto;
    background: #FFFFFF;
border-radius: 10px;
margin: 0 auto 30px;
.b1{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    .b11{
        display: flex;
        align-items: center;
        .b111{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
        }
        .b112{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FF5602;
            margin-left: 33px;
        }
    }
    .b12{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
        div{
            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #666666;
        }
    }
}
.b2{
    display: flex;
    align-items: center;
    .b21{
        font-size: 18px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
margin-right: 48px;
    }
    .b22{
        font-size: 18px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
background: #1989fa11;
border-radius: 2px;
padding: 0 8px;
    }
}
.b3{
    font-size: 18px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
margin-top: 20px;
}
}
.el-pagination{
    text-align: center;
    margin-top: 36px;
    /deep/ .el-pager li,/deep/ .btn-next,/deep/ .btn-prev{
        background: transparent;
    }
    /deep/ .el-pager li:not(.disabled).active{
        border-radius: 50%;
        background: #88C0F8;
    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/recruitment/index.vue